import gsap from "gsap"
import ActionButton from "./ActionButton.js"

export default class Form {

    constructor(element,page) {

        this.formElement = element
        this.page = page
        this.app = this.page.parent
        this.notificationSystem = this.app.noficationSystem
    
        this.endpoint = this.formElement.dataset.location
        this.method = this.formElement.dataset.method || "POST"
        
        this.actionButtonElement =
            this.formElement.querySelector(".action_button")

        this.actionButton = null

        if (this.actionButtonElement) {
            this.actionButton = new ActionButton(
                this.actionButtonElement,
                this
            )
        }

        this.fields = []

        this.init()
    }

    destroy(){


    }

    init() {

        this.getFields()

        this.formElement.addEventListener(
            "submit",
            this.handleSubmit.bind(this)
        )

        if (this.actionButtonElement) {

            this.actionButtonElement.addEventListener(
                "click",
                this.handleButtonClick.bind(this)
            )

        }

    }


    getFields() {

        const elements = this.formElement.querySelectorAll(
            "[data-query]"
        )

        this.fields = Array.from(elements)

    }


    handleButtonClick(e) {

        e.preventDefault()

        this.submit()

    }


    async handleSubmit(e) {

        e.preventDefault()

        await this.submit()

    }


    getFormData() {

        const data = {}

        this.fields.forEach(field => {

            const query = field.dataset.query

            const input =
                field.querySelector(
                    "input, select, textarea"
                )

            if (!input || !query) return

            data[query] = input.value

        })

        return data

    }


    validate(data) {

        let valid = true

        this.fields.forEach(field => {

            const input =
                field.querySelector(
                    "input, select, textarea"
                )

            if (!input) return

            const required =
                field.querySelector(".required")

            if (!required) return

            if (!input.value.trim()) {

                field.classList.add("error")

                valid = false

            } else {

                field.classList.remove("error")

            }

        })

        return valid

    }


    async submit() {

        const data = this.getFormData()
        if (!this.validate(data)) {
            this.notificationSystem.onTriggerError("Error validating fields.")
            return
        }

        try {

            if (this.actionButton) {
                await this.actionButton.triggerLoad()
            }

            const response = await fetch(
                this.endpoint,
                {
                    method: this.method,

                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },

                    body: JSON.stringify(data)
                }
            )

            const result = await response.json()

            if (!response.ok) {
                throw new Error(
                    result.message ||
                    "Something went wrong."
                )
            }

            await this.handleSuccess(result)

        } catch (error) {
            
            console.error(
                "Booking submission failed:",
                error
            )

            await this.handleError(error)

        } finally {

            if (this.actionButton) {
                await this.actionButton.triggerLoadComplete()
            }

        }

    }


    async handleSuccess(result) {

        console.log(
            "Booking submitted:",
            result
        )

        this.formElement.classList.add("success")
        this.notificationSystem.onTriggerSuccess("Your booking was submitted successfully.")
        // You can replace this with your success UI
        // or redirect the user here.

    }


    async handleError(error) {

        this.formElement.classList.add("error")
        this.notificationSystem.onTriggerError("Unable to submit your booking. Please try again.")

    }

}